<template>
    <md-layout class="ql-pages-container" style="overflow: auto;justify-content: center;">
        <md-layout v-if="selectedPageType === 'no' || (selectedPageType === 'even' && ( ( totalPages % 2 === 0 && totalPages === currentPage ) || currentPage === 1 ))" md-row md-gutter="12" class="ql-page-layout">
            <div class="ql-pages-inner" :id="`pageNumber${currentPage}`">
                
                <svg class="ql-page-graphics" v-bind:class="{withBookmarkNav: bookmarkNavOpened}" xmlns="http://www.w3.org/2000/svg" version="1.1"
                    :style="{height: `${svgTrueHeight}px`, overflow: `${showMarginView ? 'visible' : 'hidden'}`}" v-if="pageReady && displayLayerCues.length > 0">
                    <!-- SVG lines connecting cues with cue markers. Y + 1 so it lines up nicely -->
                    <line
                        v-for="cue in visiblePositionedCues"
                        :key="cue.id"
                        class="ql-page-cue-line"
                        :x1="cue.lineX1"
                        :y1="cue.lineY1"
                        :x2="cue.lineX2"
                        :y2="cue.lineY2"
                        stroke-width="1"
                        :stroke-opacity="lineOpacity(cue)"
                        v-bind:style="cueLineOpacityStyle(cue)"
                    />
                </svg>
                <project-page
                    :key="currentPage"
                    :page="currentProjectPage"
                    :locked="locked"
                    :positionedCues="positionedCues"
                    :svgTrueHeight="svgTrueHeight"
                    :showMode="showMode"
                    :bookmarked="currentPageBookmarked"
                    :bookmarkNavOpened="bookmarkNavOpened"
                    :issrc="project.issrc"
                    :openCues="openCues"
                    @setSelectedElement="setSelectedElement"
                    @updatePageHistory="updatePageHistory"
                    @pageLoaded="pageLoaded"
                    @addedCue="addedCue"
                    @deletedCue="deletedCue"
                    @updatedCue="updatedCue"
                    @copyElement="copyElement"
                    @toggleBookmarkNav="toggleBookmarkNav"
                    @openBookmarkNav="openBookmarkNav"
                    @setBookmarkTab="setBookmarkTab"
                    :selectedElement="selectedElement"
                    class="md-flex ql-project-page"
                    :style="{order: pdfPaneOrderByCuePlacement()}"
                />
                <project-cue-list
                    v-if="displayLayerCues.length > 0"
                    :currentPage="currentPage"
                    :cues="visiblePositionedCues"
                    :locked="locked"
                    :openCues="openCues"
                    :globalCuesLength="cuesLength"
                    :cuesListWidth="cuesListWidth"
                    :svgContentWidth="svgContentWidth"
                    :svgTrueHeight="svgTrueHeight"
                    @openCue="openCue"
                    @closeCue="closeCue"
                    @destroy="deletedCue"
                    @updatedCue="updatedCue"
                    :style="cuesListStyles()"
                />
            </div>
        </md-layout>

        <div v-else="" class="spread">
        <md-layout md-row md-gutter="6" class="ql-page-layout">
                <div class="ql-pages-inner" :id="`pageNumber${currentPage}`">
                    <svg class="ql-page-graphics" v-bind:class="{withBookmarkNav: bookmarkNavOpened}" xmlns="http://www.w3.org/2000/svg" version="1.1"
                        :style="{height: `${svgTrueHeight}px`}" v-if="pageReady && displayLayerCues.length > 0">
                        <!-- SVG lines connecting cues with cue markers. Y + 1 so it lines up nicely -->
                        <line
                            v-for="cue in visiblePositionedCues"
                            :key="cue.id"
                            class="ql-page-cue-line"
                            :x1="cue.lineX1"
                            :y1="cue.lineY1"
                            :x2="cue.lineX2"
                            :y2="cue.lineY2"
                            stroke-width="1"
                            :stroke-opacity="lineOpacity(cue)"
                            v-bind:style="cueLineOpacityStyle(cue)"
                        />
                    </svg>
                    <project-page
                        :key="currentPage"
                        :page="currentProjectPage"
                        :locked="locked"
                        :positionedCues="positionedCues"
                        :svgTrueHeight="svgTrueHeight"
                        :showMode="showMode"
                        @setSelectedElement="setSelectedElement"
                        :selectedElement="selectedElement"
                        @updatePageHistory="updatePageHistory"
                        :bookmarked="currentPageBookmarked"
                        :bookmarkNavOpened="bookmarkNavOpened"
                        :issrc="project.issrc"
                        :openCues="openCues"
                        @pageLoaded="pageLoaded"
                        @addedCue="addedCue"
                        @deletedCue="deletedCue"
                        @copyElement="copyElement"
                        @updatedCue="updatedCue"
                        @toggleBookmarkNav="toggleBookmarkNav"
                        @openBookmarkNav="openBookmarkNav"
                        @setBookmarkTab="setBookmarkTab"
                        class="md-flex ql-project-page"
                        :style="{order: pdfPaneOrderByCuePlacement()}"
                    />
                    <project-cue-list
                        v-if="displayLayerCues.length > 0"
                        :currentPage="currentPage"
                        :cues="visiblePositionedCues"
                        :locked="locked"
                        :openCues="openCues"
                        :globalCuesLength="cuesLength"
                        :cuesListWidth="cuesListWidth"
                        :svgContentWidth="svgContentWidth"
                        :svgTrueHeight="svgTrueHeight"
                        @openCue="openCue"
                        @closeCue="closeCue"
                        @destroy="deletedCue"
                        @updatedCue="updatedCue"
                        :style="cuesListStyles()"
                    />
                </div>
            </md-layout>

            <md-layout v-if="currentPage + 1 <= totalPages" md-row md-gutter="6" class="ql-page-layout">
                <div class="ql-pages-inner" :id="`pageNumber${currentPage + 1}`">
                    <svg class="ql-page-graphics" v-bind:class="{withBookmarkNav: bookmarkNavOpened}" xmlns="http://www.w3.org/2000/svg" version="1.1"
                        :style="{height: `${svgTrueNextHeight}px`}" v-if="pageReady && displayLayerNextCues.length > 0">
                        <!-- SVG lines connecting cues with cue markers. Y + 1 so it lines up nicely -->
                        <line
                            v-for="cue in positionedNextCues"
                            :key="cue.id"
                            class="ql-page-cue-line"
                            :x1="cue.lineX1"
                            :y1="cue.lineY1"
                            :x2="cue.lineX2"
                            :y2="cue.lineY2"
                            stroke-width="1"
                            :stroke-opacity="lineOpacity(cue)"
                            v-bind:style="cueLineOpacityStyle(cue)"
                        />
                    </svg>
                    <!-- {{ currentProjectPage }} -->
                    <project-page
                        :key="currentPage + 1"
                        :page="nextProjectPage"
                        :locked="locked"
                        :showMode="showMode"
                        @setSelectedElement="setSelectedElement"
                        @updatePageHistory="updatePageHistory"
                        :positionedCues="positionedNextCues"
                        :svgTrueHeight="svgTrueHeight"
                        :bookmarked="nextPageBookmarked"
                        :bookmarkNavOpened="bookmarkNavOpened"
                        :issrc="project.issrc"
                        :openCues="openCues"
                        @pageLoaded="pageLoaded"
                        :selectedElement="selectedElement"
                        @copyElement="copyElement"
                        @addedCue="addedCue"
                        @deletedCue="deletedCue"
                        @updatedCue="updatedCue"
                        @toggleBookmarkNav="toggleBookmarkNav"
                        @openBookmarkNav="openBookmarkNav"
                        @setBookmarkTab="setBookmarkTab"
                        class="md-flex ql-project-page"
                        :style="{order: pdfPaneOrderByCuePlacement()}"
                    />
                    <project-cue-list 
                        v-if="displayLayerNextCues.length > 0"
                        :currentPage="currentPage + 1"
                        :cues="positionedNextCues"
                        :locked="locked"
                        :openCues="openCues"
                        :globalCuesLength="cuesLength"
                        :cuesListWidth="cuesListWidth"
                        :svgContentWidth="svgContentWidth"
                        :svgTrueHeight="svgTrueHeight"
                        @openCue="openCue"
                        @closeCue="closeCue"
                        @destroy="deletedCue"
                        @updatedCue="updatedCue"
                        :style="cuesListStyles()"
                    />
                </div>
            </md-layout>
        </div>
    </md-layout>
</template>

<script>
import { bookmarksShown } from '@/lib/bookmark-rename';
import { mapGetters } from 'vuex';

import ProjectPage from '@/components/project/page';
import ProjectCueList from '@/components/project/cues/cue-list';

// Stage A slice 2: how far above/below the scroll viewport (px) to keep cues
// mounted, so scrolling never reveals an unmounted cue.
const CUE_VIRT_OVERSCAN = 800;

const ProjectPages = {
    name: 'projectPages',
    props: [
        'currentPage',
        'totalPages',
        'locked',
        'showMode',
        'bookmarkNavOpened',
        'selectedElement',
        'pageHeight',
        'showMarginView'
    ],
    data: function() {
        return {
            svgOffsetStart: 0,
            svgOffsetEnd: 0,
            cueHeight: 22,
            cueOpenHeight: 180,
            cueBottomPadding: 5,
            svgHeight: 100,
            svgContentWidth: 100,
            pageReady: false,
            openCues: [],
            cuesListWidth: 400,
            wheelHistory: [],
            // Stage A slice 2: scroll-viewport window for cue virtualization.
            viewportTop: 0,
            viewportHeight: 0,
            pageScrollTop: 0
        };
    },
    watch: {
        bookmarkNavOpened: function() {
            let elmParent = null;
            if (this.bookmarkNavOpened) {
                elmParent = document.querySelector('.ql-pages-container');
            } else {
                elmParent = document.querySelector('.page-viewer');
            }
            if (elmParent) {
                this.cuesListWidth = Math.min(elmParent.clientWidth * 0.3, 500);
            }
        },
        currentPage: function() {
            // Re-anchor the virtualization window after a page change.
            this.$nextTick(() => this.updateCueViewport());
        }
    },
    computed: {
        ...mapGetters([
            'project',
            'user',
            'layerByCue',
            'visibleCues',
            'cuesLength',
            'currentCueLayer',
            'bookmarks',
            'floatingCues',
            'cuePlacement',
            'selectedPageType',
            'selectedScale',
            'getDefaultCuePlacement',
            'getCueLineOpacity',
            'getCueFontSize',
            'cuesByPageLayer',
            'currentVersion'
        ]),
        ...mapGetters({
            pages: 'projectPages'
        }),
        displayLayerCues: function() {
            return this.cuesByPageLayer(this.currentPage);
        },
        displayLayerNextCues: function() {
            return this.cuesByPageLayer(this.currentPage + 1);
        },
        positionedCues: function() {
            // A cue saved with no position (x/y NaN, seen 28 Oct on a sandbox show) is never drawn; left in, its NaN made
            // the sort below inconsistent and scrambled the stacking of the cues around it.
            const allCues = this.visibleCues(this.currentPage).filter(c => Number.isFinite(Number(c.y)));
            allCues.sort((a, b) => {
                if (a.y === b.y) {
                    return a.x - b.x;
                }

                return a.y - b.y;
            });
            const positionedCues = [];

            const floatingCuesIDs = Object.keys(this.floatingCues);

            // Stage A slice 3: identity-preserving memo. Kills the reactivity
            // fan-out — when one cue (or one collaborator's synced change) updates,
            // reuse the SAME result object for every cue whose content + geometry
            // context is unchanged, so only the changed cue's component re-renders.
            if (!this.posCache) this.posCache = new Map();
            const cache = this.posCache;
            const nextCache = new Map();
            const globalSig = `${this.selectedScale}|${this.svgHeight}|${this.svgContentWidth}|${this.svgOffsetStart}|${this.svgOffsetEnd}|${window.devicePixelRatio}`;

            for (const cueItem of allCues) {
                // Memo key: this cue's full content + the prior non-floating cue's
                // resulting offset (the anti-overlap dependency) + floating pos +
                // global inputs. Same key => output provably identical => reuse.
                let prevSig = '';
                for (let p = positionedCues.length - 1; p >= 0; p--) {
                    if (!floatingCuesIDs.includes(positionedCues[p].id)) {
                        prevSig = `${positionedCues[p].offsetY}|${positionedCues[p].currentHeight}`;
                        break;
                    }
                }
                const floatSig = floatingCuesIDs.includes(cueItem.id) ? JSON.stringify(this.floatingCues[cueItem.id]) : '';
                // Derived inputs this loop READS but which are NOT part of the cue
                // document: cue placement and the heights, which come from the
                // LAYER (placement, titleFontSize) and the per-cue option stores.
                // Without them in the key, changing a layer's cue placement or
                // font size leaves the key identical, the cached result is reused,
                // and the connector lines keep the geometry of the old placement
                // while the cue boxes move — lines pointing off the wrong side.
                const derivedSig = [
                    this.getDefaultCuePlacement(cueItem.layer),
                    this.getCueHeaderHeight(cueItem),
                    this.getCueBodyHeight(cueItem),
                    this.getCuePointHeight(cueItem)
                ].join('|');
                const memoKey = `${JSON.stringify(cueItem)}|${prevSig}|${floatSig}|${globalSig}|${derivedSig}`;
                const cachedEntry = cache.get(cueItem.id);
                if (cachedEntry && cachedEntry.key === memoKey) {
                    positionedCues.push(cachedEntry.result);
                    nextCache.set(cueItem.id, cachedEntry);
                    // eslint-disable-next-line no-continue
                    continue;
                }
                // shallow copy is sufficient — this loop only ADDS top-level derived
                // props (offset*/line*/currentHeight) and READS top-level fields, so
                // the store cue is never mutated.
                const cue = { ...cueItem };
                const defaultCuePlacement = this.getDefaultCuePlacement(cue.layer);
                const isFloatingCue = floatingCuesIDs.includes(cue.id);

                cue.currentHeight = this.getCueBodyHeight(cue);
                if (cue.y <= 1 && cue.x <= 1) {
                    cue.offsetY = cue.y * this.svgHeight;
                    cue.offsetX = (cue.x * this.svgContentWidth) + this.svgOffsetStart;
                } else {
                    cue.offsetY = cue.y;
                    cue.offsetX = cue.x + this.svgOffsetStart;
                }

                if (positionedCues.length > 0) {
                    let otherCue = null;
                    for (let p = positionedCues.length - 1; p >= 0; p--) {
                        if (!floatingCuesIDs.includes(positionedCues[p].id)) {
                            otherCue = positionedCues[p];
                            break;
                        }
                    }
                    if (otherCue) {
                        if ((cue.offsetY - this.getCueHeaderHeight(cue)) + this.getCuePointHeight(cue) < (otherCue.offsetY + otherCue.currentHeight) + this.getCuePointHeight(otherCue)) {
                            if (defaultCuePlacement === 'left' || defaultCuePlacement === 'leftEdge') {
                                cue.offsetY = (otherCue.offsetY + Math.abs(otherCue.currentHeight) + this.getCueHeaderHeight(cue) + this.getCuePointHeight(otherCue)) - (this.getCuePointHeight(cue) + (2.4 * this.selectedScale));
                            }
                            if (defaultCuePlacement === 'right' || defaultCuePlacement === 'rightEdge') {
                                cue.offsetY = (otherCue.offsetY + Math.abs(otherCue.currentHeight) + this.getCueHeaderHeight(cue) + this.getCuePointHeight(otherCue)) - (this.getCuePointHeight(cue) + (2.6 * this.selectedScale));
                            }
                        }
                    }
                }

                if (defaultCuePlacement === 'right') {
                    const cueFixPos = window.devicePixelRatio === 1.25 ? 3 : 0;
                    cue.lineX1 = cue.offsetX + Math.min((cue.width * this.selectedScale), cue.type === 'position' ? cueFixPos : 9999);
                    cue.lineY1 = this.cuePosTop(cue) + (((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale) - 0.5);
                    cue.lineX2 = this.svgOffsetEnd - 15 - 2;
                    cue.lineY2 = cue.offsetY + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                } else if (defaultCuePlacement === 'left') {
                    const cueFixPos = window.devicePixelRatio === 1.25 ? 3 : 1;
                    cue.lineX1 = 2;
                    cue.lineY1 = cue.offsetY + (((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale) - 0.5);
                    cue.lineX2 = cue.offsetX + cueFixPos;
                    cue.lineY2 = this.cuePosTop(cue) + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                } else if (defaultCuePlacement === 'leftEdge') {
                    const cueFixPos = window.devicePixelRatio === 1.25 ? 3 : 1;
                    cue.lineX1 = 2 - 17;
                    cue.lineY1 = cue.offsetY + (((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale) - 0.5);
                    cue.lineX2 = (cue.offsetX + cueFixPos) + 2;
                    cue.lineY2 = this.cuePosTop(cue) + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                } else if (defaultCuePlacement === 'rightEdge') {
                    cue.lineX1 = cue.offsetX + (Math.min((cue.width * this.selectedScale), cue.type === 'position' ? 6 : 9999) - 5);
                    cue.lineY1 = this.cuePosTop(cue) + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                    cue.lineX2 = this.svgOffsetEnd;
                    cue.lineY2 = cue.offsetY + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                }

                if (isFloatingCue) {
                    if ((defaultCuePlacement === 'left' || defaultCuePlacement === 'leftEdge') && cue.type === 'selection') {
                        cue.lineX1 = cue.offsetX + (Math.min((cue.width * this.selectedScale), 5) - 4);
                    } else if ((defaultCuePlacement === 'left' || defaultCuePlacement === 'leftEdge') && cue.type === 'position') {
                        cue.lineX1 = cue.offsetX + (Math.min((cue.width * this.selectedScale), cue.type === 'position' ? 6 : 9999) - 4);
                    } else if (defaultCuePlacement === 'right' && cue.type === 'position') {
                        cue.lineX1 = cue.offsetX + (Math.min((cue.width * this.selectedScale), cue.type === 'position' ? 6 : 9999) - 4);
                    } else if (defaultCuePlacement === 'right' && cue.type === 'selection') {
                        cue.lineX1 = cue.offsetX + (cue.width * this.selectedScale);
                    } 
                    cue.lineY1 = this.cuePosTop(cue) + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                    cue.lineX2 = (this.floatingCues[cue.id].left) * this.selectedScale;
                    cue.lineY2 = (this.floatingCues[cue.id].top + ((12 * this.selectedScale) / this.selectedScale)) * this.selectedScale;
                }
                nextCache.set(cueItem.id, { key: memoKey, result: cue });
                positionedCues.push(cue);
            }
            this.posCache = nextCache;
            return positionedCues;
        },
        // Stage A slice 2 — cue virtualization. Filters the FULL positionedCues
        // output (geometry untouched) to only the cues whose vertical span is near
        // the scroll viewport, so the heavy per-cue components/lines mount only for
        // what is visible. Before the viewport is measured, renders all (safe).
        visiblePositionedCues: function() {
            const all = this.positionedCues;
            if (!this.viewportHeight) return all;
            const top = this.viewportTop - CUE_VIRT_OVERSCAN;
            const bottom = this.viewportTop + this.viewportHeight + CUE_VIRT_OVERSCAN;
            return all.filter((cue) => {
                const start = this.pageScrollTop + cue.offsetY;
                const end = start + Math.abs(cue.currentHeight || 0);
                return end >= top && start <= bottom;
            });
        },
        svgTrueHeight: function() {
            return this.pageHeight;
        },
        positionedNextCues: function() {
            // Same as the page on the left: a cue with no position is never drawn and must not reach the sort.
            const allCues = this.visibleCues(this.currentPage + 1).filter(c => Number.isFinite(Number(c.y)));
            allCues.sort((a, b) => {
                if (a.y === b.y) {
                    return a.x - b.x;
                }

                return a.y - b.y;
            });
            const positionedCues = [];

            const floatingCuesIDs = Object.keys(this.floatingCues);

            for (const cueItem of allCues) {
                // Stage A: shallow copy is sufficient — this loop only ADDS top-level
                // derived props (offset*/line*/currentHeight) and READS top-level fields,
                // so the store cue is never mutated. Replaces a per-cue JSON deep-clone
                // that ran on every recompute (a hot-path cost at cue density).
                const cue = { ...cueItem };
                const defaultCuePlacement = this.getDefaultCuePlacement(cue.layer);
                const isFloatingCue = floatingCuesIDs.includes(cue.id);

                cue.currentHeight = this.getCueBodyHeight(cue);
                if (cue.y <= 1 && cue.x <= 1) {
                    cue.offsetY = cue.y * this.svgHeight;
                    cue.offsetX = (cue.x * this.svgContentWidth) + this.svgOffsetStart;
                } else {
                    cue.offsetY = cue.y;
                    cue.offsetX = cue.x + this.svgOffsetStart;
                }

                if (positionedCues.length > 0) {
                    let otherCue = null;
                    for (let p = positionedCues.length - 1; p >= 0; p--) {
                        if (!floatingCuesIDs.includes(positionedCues[p].id)) {
                            otherCue = positionedCues[p];
                            break;
                        }
                    }
                    if (otherCue) {
                        if ((cue.offsetY - this.getCueHeaderHeight(cue)) + this.getCuePointHeight(cue) < (otherCue.offsetY + otherCue.currentHeight) + this.getCuePointHeight(otherCue)) {
                            if (defaultCuePlacement === 'left') {
                                cue.offsetY = (otherCue.offsetY + otherCue.currentHeight + this.getCueHeaderHeight(cue) + this.getCuePointHeight(otherCue)) - (this.getCuePointHeight(cue) + (2.2 * this.selectedScale));
                            }
                            if (defaultCuePlacement === 'right') {
                                cue.offsetY = (otherCue.offsetY + otherCue.currentHeight + this.getCueHeaderHeight(cue) + this.getCuePointHeight(otherCue)) - (this.getCuePointHeight(cue) + (2.6 * this.selectedScale));
                            }
                        }
                    }
                }

                if (defaultCuePlacement === 'right') {
                    const cueFixPos = window.devicePixelRatio === 1.25 ? 3 : 0;
                    cue.lineX1 = cue.offsetX + Math.min((cue.width * this.selectedScale), cue.type === 'position' ? cueFixPos : 9999);
                    cue.lineY1 = this.cuePosTop(cue) + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                    cue.lineX2 = this.svgOffsetEnd - 15 - 2;
                    cue.lineY2 = cue.offsetY + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                } else if (defaultCuePlacement === 'left') {
                    const cueFixPos = window.devicePixelRatio === 1.25 ? 3 : 1;
                    cue.lineX1 = 2;
                    cue.lineY1 = cue.offsetY + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                    cue.lineX2 = cue.offsetX + cueFixPos;
                    cue.lineY2 = this.cuePosTop(cue) + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                } else if (defaultCuePlacement === 'leftEdge') {
                    cue.lineX1 = this.cuesListWidth - 15;
                    cue.lineY1 = cue.offsetY + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                    cue.lineX2 = this.cuesListWidth + cue.offsetX;
                    cue.lineY2 = this.cuePosTop(cue) + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                } else if (defaultCuePlacement === 'rightEdge') {
                    cue.lineX1 = cue.offsetX + Math.min((cue.width * this.selectedScale), cue.type === 'position' ? 6 : 9999);
                    cue.lineY1 = this.cuePosTop(cue) + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                    cue.lineX2 = this.svgOffsetEnd;
                    cue.lineY2 = cue.offsetY + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                }

                if (isFloatingCue) {
                    if (defaultCuePlacement === 'left' && cue.type === 'selection') {
                        cue.lineX1 = cue.offsetX + (Math.min((cue.width * this.selectedScale), 5) - 4);
                    } else if (defaultCuePlacement === 'left' && cue.type === 'position') {
                        cue.lineX1 = cue.offsetX + (Math.min((cue.width * this.selectedScale), cue.type === 'position' ? 6 : 9999) - 4);
                    } else if (defaultCuePlacement === 'right' && cue.type === 'position') {
                        cue.lineX1 = cue.offsetX + (Math.min((cue.width * this.selectedScale), cue.type === 'position' ? 6 : 9999) - 4);
                    } else if (defaultCuePlacement === 'right' && cue.type === 'selection') {
                        cue.lineX1 = cue.offsetX + (cue.width * this.selectedScale);
                    } 
                    cue.lineY1 = this.cuePosTop(cue) + ((cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale);
                    cue.lineX2 = (this.floatingCues[cue.id].left) * this.selectedScale;
                    cue.lineY2 = (this.floatingCues[cue.id].top + ((12 * this.selectedScale) / this.selectedScale)) * this.selectedScale;
                }
                positionedCues.push(cue);
            }

            return positionedCues;
        },
        svgTrueNextHeight: function() {
            const lastElement = this.positionedNextCues[this.positionedNextCues.length - 1];
            if (lastElement) {
                return Math.max(this.svgHeight, lastElement.offsetY);
            }

            return this.svgHeight;
        },
        currentProjectPage: function() {
            return this.pages[this.currentPage - 1];
        },
        nextProjectPage: function() {
            return this.pages[this.currentPage];
        },
        currentPageBookmarked: function() {
            return this.currentPage in bookmarksShown(this.currentVersion, this.bookmarks);
        },
        nextPageBookmarked: function() {
            return this.currentPage + 1 in bookmarksShown(this.currentVersion, this.bookmarks);
        }
    },
    methods: {
        cueColor(cue) {
            const layer = this.layerByCue(cue);
            if (layer) return layer.color;

            return 'black';
        },
        getCueBodyHeight() {
            return this.cueBottomPadding * this.selectedScale;
        },
        getCueHeaderHeight(cue) {
            return (this.getCueFontSize(cue) || this.layerByCue(cue).titleFontSize || 14) * 1.1 * this.selectedScale;
        },
        getCuePointHeight(cue) {
            return (cue.type === 'position' ? (cue.height / 2) : cue.height) * this.selectedScale;
        },
        cuePosTop(cue) {
            if (cue.x <= 1 && cue.y <= 1) {
                return (cue.y * this.svgHeight) + 1;
            }
            return cue.y + 1;
        },
        pdfPaneOrderByCuePlacement() {
            return this.cuePlacement === 'right' ? 2 : 4;
        },
        lineOpacity(cue) {
            if (cue.lineOpacity !== undefined) {
                return cue.lineOpacity / 100;
            }
            const lineOpacity = this.getCueLineOpacity(cue);
            if (lineOpacity !== undefined) {
                return lineOpacity / 100;
            }
            return 0;
        },
        cueLineOpacityStyle(cue) {
            return '{opacity: ' + this.lineOpacity(cue) + ';}';
        },
        inRange(key) {
            return key > (this.$props.currentPage - 2) && key < (this.$props.currentPage + 2);
        },
        current(key) {
            return this.$props.currentPage === key;
        },
        bookmarked(key) {
            return key in this.bookmarks;
        },
        openCue(cue) {
            this.openCues.push({id: cue.id, height: cue.height / this.selectedScale});
        },
        closeCue(cue) {
            const cueIndex = this.openCues.findIndex(c => c.id === cue.id);
            this.openCues.splice(cueIndex, 1);
        },
        addedCue: function(cue) {
            this.$store.dispatch('addCue', cue);
        },
        deletedCue: function(cue) {
            this.$store.dispatch('deleteCue', cue);
        },
        updatedCue: function(cue) {
            this.$store.dispatch('updateCue', cue);
        },
        pageLoaded(data) {
            this.svgHeight = data.pageHeight;
            this.svgContentWidth = data.pageWidth;
            this.svgOffsetEnd = Math.min(data.width, data.pageWidth) + 15;

            const elmParent = document.querySelector('.ql-pages-container');
            if (elmParent) {
                this.cuesListWidth = 500;
            }

            if (data.viewport) {
                this.scale = this.selectedScale;
            }

            this.$emit('getPageWidth', data.pageWidth);
            this.$emit('getPageHeight', data.pageHeight);
            this.$store.commit('updatePageSize', {
                width: this.svgContentWidth,
                height: this.svgHeight
            });

            this.pageReady = true;
            // Re-anchor the virtualization window once the page has rendered.
            this.$nextTick(() => this.updateCueViewport());
        },
        sortCues(cues) {
            return cues.sort((a, b) => {
                if (a.y === b.y) {
                    if (a.x === b.x) {
                        return a.id > b.id;
                    }
                    return a.x > b.x;
                }

                return a.y > b.y;
            });
        },
        getCueRect(cue) {
            return {
                left: 0,
                top: cue.offsetY,
                right: 10,
                bottom: cue.offsetY + cue.currentHeight
            };
        },
        intersectRect(r1, r2) {
            return !(r2.left > r1.right ||
                   r2.right < r1.left ||
                   r2.top > r1.bottom ||
                   r2.bottom < r1.top);
        },
        toggleBookmarkNav() {
            this.$emit('toggleBookmarkNav');
        },
        openBookmarkNav(tab, focusPage) {
            this.$emit('openBookmarkNav', tab, focusPage);
        },
        setBookmarkTab(tab) {
            this.$emit('setBookmarkTab', tab);
        },
        setSelectedElement(data) {
            this.$emit('setSelectedElement', data);
        },
        copyElement(data) {
            this.$emit('copyElement', data);
        },
        updatePageHistory(data) {
            this.$emit('updatePageHistory', data);
        },
        gotoPage(e) {
            this.$emit('gotoPage', e);
        },
        handleWheel(e) {
            if (this.wheelTimerID) {
                clearTimeout(this.wheelTimerID);
            }
            const container = document.querySelector('.ql-pages-container');
            if (!container) return;
            if (e.wheelDeltaY < 0) {
                if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
                    this.wheelDirection = 'up';
                } else {
                    this.wheelDirection = '';
                }
            }
            if (e.wheelDeltaY > 0) {
                if (container.scrollTop <= 0) {
                    this.wheelDirection = 'down';
                } else {
                    this.wheelDirection = '';
                }
            }
            if (this.wheelDirection) {
                if (Math.abs(e.wheelDeltaY) > 300) {
                    this.wheelHistory.push(this.wheelDirection);
                }
                this.wheelTimerID = setTimeout(() => {
                    if (this.wheelHistory.length === 0) return;
                    const wheelDirection = this.wheelHistory[this.wheelHistory.length - 1];
                    if (wheelDirection === 'up') {
                        this.$nextTick(() => {
                            this.gotoPage(this.currentPage + 1);
                        });
                    }
                    if (wheelDirection === 'down') {
                        this.$nextTick(() => {
                            this.gotoPage(this.currentPage - 1);
                        });
                    }
                    this.wheelDirection = '';
                    this.wheelTimerID = null;
                    this.wheelHistory = [];
                }, 200);
            }
        },
        cuesListStyles() {
            const styles = {
                order: 3
            };
            return styles;
        },
        // --- Stage A slice 2: cue virtualization viewport tracking ---
        updateCueViewport() {
            const el = this.cueScrollEl || document.querySelector('.ql-pages-container');
            if (!el) return;
            this.cueScrollEl = el;
            this.viewportTop = el.scrollTop;
            this.viewportHeight = el.clientHeight;
            const pageEl = document.getElementById(`pageNumber${this.currentPage}`);
            if (pageEl) {
                const rect = pageEl.getBoundingClientRect();
                const cRect = el.getBoundingClientRect();
                this.pageScrollTop = (rect.top - cRect.top) + el.scrollTop;
            } else {
                this.pageScrollTop = 0;
            }
        },
        onCueScroll() {
            if (this.cueScrollRaf) return;
            this.cueScrollRaf = requestAnimationFrame(() => {
                this.cueScrollRaf = null;
                this.updateCueViewport();
            });
        },
        attachCueViewport() {
            const el = document.querySelector('.ql-pages-container');
            if (!el) return;
            this.cueScrollEl = el;
            this.updateCueViewport();
            el.addEventListener('scroll', this.onCueScroll, { passive: true });
        },
        detachCueViewport() {
            if (this.cueScrollEl) {
                this.cueScrollEl.removeEventListener('scroll', this.onCueScroll);
                this.cueScrollEl = null;
            }
            if (this.cueScrollRaf) {
                cancelAnimationFrame(this.cueScrollRaf);
                this.cueScrollRaf = null;
            }
        }
    },
    components: {
        'project-page': ProjectPage,
        'project-cue-list': ProjectCueList
    },
    mounted() {
        this.$nextTick(() => this.attachCueViewport());
    },
    beforeDestroy() {
        this.detachCueViewport();
    }
};

export default ProjectPages;
</script>

<style lang="scss">
.ql-page-container {
    padding: .5em 0 0 0 ;
}
.ql-page-layout {
    position: relative;
    // NO z-index here. Two of these sit side by side in two-page view
    // (pages.vue "spread"), and an equal z-index on both made them competing
    // stacking contexts -- so the RIGHT page's canvas painted over the LEFT
    // page's Notes List icon, which hangs ~21px outside its page by design.
    // The icon could not be raised out of that: a z-index on a descendant
    // cannot escape its own stacking context. Without one here, the cue layer
    // participates in .ql-pages-container's context instead and its existing
    // z-index outranks the canvases -- in BOTH directions, which matters for
    // leftEdge/margin-view cues on the right page that overhang the other way.
    // .ql-pages-container keeps z-index 18, so the block as a whole still sits
    // where it did relative to the list view (19) and the bookmark nav (20).
}
// Room for the Notes List icon between the pages, so in the common case it
// lands in empty space rather than on the neighbouring page's script. The
// stacking fix above is what GUARANTEES it is visible and clickable: the icon
// is sized from the cue box height, so it grows with zoom and no fixed gap can
// always contain it.
// The specificity here is deliberate and must not be reduced. The pages carry
// `margin: 9px 4.5px` from palette/index.vue:
//     .md-layout.page-viewer .ql-pages-container .ql-page-layout
// which is FOUR classes. That 4.5px on each facing edge IS the 9px gutter. A
// shorter selector here loses the cascade silently -- no error, no warning, the
// rule simply never applies -- which is exactly what happened twice while
// fixing this. Match that rule's context, then add one class for the spread.
.md-layout.page-viewer .ql-pages-container .spread .ql-page-layout + .ql-page-layout {
    margin-left: 24px;   // + the inherited 4.5px = a 28.5px gutter, which
                         // just contains the icon's 21px overhang at 100%
}
.ql-page-graphics {
    position: absolute;
    z-index: 10;
    width: 100%;
    pointer-events: none;
    .ql-page-cue-line {
        stroke: #818181;
    }
}

.md-theme-show-mode {
    .ql-page-graphics {
        .ql-page-cue-line {
            stroke: #ffffff;
        }
    }
}

.ql-page-graphics .resizeable {
    pointer-events: stroke;
    cursor: nwse-resize;
}

.ql-page-graphics .moveable {
    pointer-events: fill;
    cursor: move;
}

.ql-button-container {
    position: relative;
}

.ql-pages-container {
    position: relative;
    z-index: 18;
}

.vdr {
  position: absolute;
  box-sizing: border-box;
}
.resizable {
    .handle {
      box-sizing: border-box;
      display: none;
      position: absolute;
      width: 10px;
      height: 10px;
      font-size: 1px;
      background: #EEE;
      border: 1px solid #333;
    }
    .handle-tl {
      top: -10px;
      left: -10px;
      cursor: nw-resize;
    }
    .handle-tm {
      top: -10px;
      left: 50%;
      margin-left: -5px;
      cursor: n-resize;
    }
    .handle-tr {
      top: -10px;
      right: -10px;
      cursor: ne-resize;
    }
    .handle-ml {
      top: 50%;
      margin-top: -5px;
      left: -10px;
      cursor: w-resize;
    }
    .handle-mr {
      top: 50%;
      margin-top: -5px;
      right: -10px;
      cursor: e-resize;
    }
    .handle-bl {
      bottom: -10px;
      left: -10px;
      cursor: sw-resize;
    }
    .handle-bm {
      bottom: -10px;
      left: 50%;
      margin-left: -5px;
      cursor: s-resize;
    }
    .handle-br {
      bottom: -10px;
      right: -10px;
      cursor: se-resize;
    }
}
</style>


// WEBPACK FOOTER //
// pages.vue?cfe7acc6